// Get basic layout config
const basicLayoutConfig = {
        style: [
            {
                selector: 'node',
                style: {
                    'font-size': '11px',
                    'font-family': 'Helvetica',
                }
            },
            {
                selector: "node.highlighted",
                style: {
                    'overlay-color': 'grey',
                    'overlay-opacity': 0.5
                }
            },
            {
                selector: 'node.dataset',
                style: {
                    'border-color': '#337ab7',
                    'border-width': "1",
                    'border-style': 'dashed',
                    'border-opacity': 0.5,
                    "background-color": "white",
                    "shape": "rectangle",
                    'width': '275px',
                    'padding': 10,

                    'color': 'white',
                    'text-background-opacity': 0,
                    'text-opacity': 0,
                    "label": "",
                    'text-events': 'yes'
                }
            },
            {
                selector: 'node.distribution',
                style: {
                    "border-color": "green",
                    'border-width': "1",
                    'border-style': 'solid',
                    "background-color": "#f5f5f5",
                    'shape': 'rectangle',
                    'width': '250px',
                    'height': 'data(height)',
                    'padding': 0,

                    "label": ""
                }
            },
            {
                selector: 'node.pathVirtualNode',
                style: {
                    'shape': 'rectangle',
                    'width': '250px',
                    'display': 'none'
                }
            },
            {
                selector: 'node.clonedNode',
                style: {
                    'display': 'none',
                    'height': 'data(height)'
                }
            },
            {
                selector: 'node.datasetClonedNode',
                style: {
                    "shape": "rectangle",
                    'width': '275px',
                }
            },
            {
                selector: 'node.distributionClonedNode',
                style: {
                    'shape': 'rectangle',
                    'width': '250px',
                }
            },
            {
                selector: 'node.level1Highlight',
                style: {
                    'line-style': 'solid',
                    'border-style': 'solid',
                    'text-background-opacity': 1,
                    'border-opacity': 1,
                }
            },
            {
                selector: 'node.level2Unhighlight',
                style: {
                    'border-opacity': 0.5,
                    'line-style': 'dashed',
                    'border-style': 'dashed',
                    'text-background-opacity': 0.5,
                }
            },
            {
                selector: "edge",
                style: {
                    "width": 1,
                    "target-arrow-shape": "triangle",
                    'z-index-compare': 'manual',
                    'z-index': 5
                }
            },
            {
                selector: "edge.highlighted",
                style: {
                    'overlay-color': 'grey',
                    'overlay-opacity': 0.5
                }
            },
            {
                selector: 'edge.level1Highlight',
                style: {
                    'border-opacity': 1,
                    'line-style': 'solid',
                    'opacity': 1,
                }
            },
            {
                selector: 'edge.level2Unhighlight',
                style: {
                    'border-opacity': 0.5,
                    'line-style': 'dashed',
                    'opacity': 0.5,
                }
            },
            {
                selector: "edge.datasetEdge",
                style: {
                    "line-color": "#337ab7",
                    "target-endpoint": "-50% 0",
                    "source-endpoint": "50% 0",
                    "target-arrow-color": "#337ab7",
                    'z-compound-depth': 'top',
                    "curve-style": "unbundled-bezier",
                }
            },
            {
                selector: "edge.distributionEdge",
                style: {
                    'line-color': 'green',
                    'target-arrow-color': 'green',
                    "target-endpoint": "-50% 0",
                    "source-endpoint": "50% 0",
                    'z-compound-depth': 'top',
                    "curve-style": "unbundled-bezier",
                }
            },
            {
                selector: "edge.pathEdge",
                style: {
                    'line-color': '#333333',
                    'target-arrow-color': '#333333',
                    "curve-style": "unbundled-bezier",
                    "target-endpoint": '-50% 0%',
                    "source-endpoint": '50% 0%',
                }
            },
        ],
        layout: {
            name: 'grid',
            avoidOverlap: true
        }
    }

const defaultFcoseLayout = {
    name: "fcose",
    animationDuration: 500,

    padding: 50,
    quality: 'proof',
    randomize: false,
    packComponents: false,
    uniformNodeDimensions: false,
    nodeDimensionsIncludeLabels: true,
    nodeSeparation: 0,
    sampleSize: 6,
    // Node repulsion (non overlapping) multiplier
    nodeRepulsion: 0.1,
    idealEdgeLength: 40,

    tilingPaddingVertical: 0,
    tilingPaddingHorizontal: 0,

    initialEnergyOnIncremental: 0.1,
    alignmentConstraint: {vertical: [], horizontal: []},
    relativePlacementConstraint: [],
    fixedNodeConstraint: []
}

const defaultLineageStatus = {
        'datasets': {
            'collapseDataset': false,
            'hide': false,
            'dashed': false,
            'dotted': true
        },
        'distributions': {
            'collapseDistribution': true,
            'hide': false,
            'dashed': true,
            'dotted': false
        },
        'paths': {
            'hide': false,
            'dashed': false,
            'dotted': true
        }
    }

export {basicLayoutConfig, defaultLineageStatus, defaultFcoseLayout}
